/**
 * Omme · Subir Fotos · omme-subir-fotos.js
 *
 * LP standalone para subida de fotos capilares desde WhatsApp.
 * URL: /pages/subir-fotos?id=<intake_uuid_o_record_id>
 *
 * Flujo:
 *   1. Lee ?id= de la URL (intake UUID o Airtable recXXXX)
 *   2. Llama al lookupUrl en PipeDream → valida existencia, obtiene nombre + record_id
 *   3. Muestra 5 slots de foto (frontal → superior → coronilla → perfil_izq → perfil_der)
 *   4. Cada foto se sube directo a Cloudinary desde el browser
 *   5. Llama al uploadUrl para guardar la URL en Airtable (con record_id resuelto)
 *   6. Al completar las 5, PipeDream marca intake_status = completed
 *   7. Muestra pantalla de confirmación personalizada
 *
 * FIX v2:
 *   - Eliminado console.log con credenciales Cloudinary
 *   - Validación de tipo y tamaño de archivo antes de subir
 *   - AbortController + timeout (15s) en el lookup fetch
 *   - webhookSecret eliminado: el header x-omme-secret ya no sale del cliente
 *   - capture="environment" en todos los slots (cámara trasera para fotos de cabello)
 */

(function () {
  'use strict';

  // ── Config ──────────────────────────────────────────────────────────────
  const cfg  = window.__OMME_FOTOS__ || {};
  const ROOT = document.getElementById('omme-fotos-root');
  const LOADER = document.getElementById('omme-fotos-loader');

  if (!ROOT) return;

  // FIX: Constantes de validación de archivo
  var ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/heic', 'image/heif', 'image/webp'];
  var MAX_FILE_SIZE = 25 * 1024 * 1024; // 25 MB

  // iOS viewport height fix
  function setVH() {
    document.documentElement.style.setProperty('--omme-vh', (window.innerHeight * 0.01) + 'px');
  }
  setVH();
  window.addEventListener('resize', setVH);

  // ── Helpers ─────────────────────────────────────────────────────────────
  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function showLoader(msg, sub) {
    var msgEl = document.getElementById('fotos-loader-msg');
    var subEl = document.getElementById('fotos-loader-sub');
    if (msgEl) msgEl.textContent = msg || '';
    if (subEl) subEl.textContent = sub || '';
    if (LOADER) LOADER.classList.remove('hidden');
  }

  function hideLoader() {
    if (LOADER) LOADER.classList.add('hidden');
  }

  function showError(elId, msg) {
    var el = document.getElementById(elId);
    if (el) { el.textContent = msg; el.style.display = 'block'; }
  }

  function clearError(elId) {
    var el = document.getElementById(elId);
    if (el) { el.textContent = ''; el.style.display = 'none'; }
  }

  // ── Leer parámetro ?id= ──────────────────────────────────────────────────
  var rawId = null;
  try {
    rawId = new URLSearchParams(window.location.search).get('id') || null;
  } catch(e) {
    var m = window.location.search.match(/[?&]id=([^&]+)/);
    rawId = m ? decodeURIComponent(m[1]) : null;
  }

  // Detectar tipo: Airtable record_id (recXXXX) o intake UUID
  var isAirtableId = rawId && /^rec[A-Za-z0-9]{14}$/.test(rawId);

  // ── Estado ────────────────────────────────────────────────────────────────
  var state = {
    slotIndex: 0,
    recordId:  null,  // resuelto en el init lookup
    nombre:    null,  // primera palabra del nombre del paciente
    photos: {
      frontal:    null,
      superior:   null,
      coronilla:  null,
      perfil_izq: null,
      perfil_der: null,
    },
  };

  var _uploadInProgress = false;

  // ── Photo slots ──────────────────────────────────────────────────────────
  var PHOTO_SLOTS = [
    {
      id:    'frontal',
      title: 'Foto frontal',
      how:   'De frente, con buena luz. El médico necesita ver tu línea de entradas y la densidad del frente.',
      ref:   'https://cdn.shopify.com/s/files/1/0748/2107/4967/files/front.png?v=1788995797',
    },
    {
      id:    'superior',
      title: 'Vista superior',
      how:   'Inclina la cabeza hacia adelante y toma desde arriba. El médico necesita ver la densidad de toda la parte superior, del frente a la coronilla.',
      ref:   'https://cdn.shopify.com/s/files/1/0748/2107/4967/files/top.png?v=1788995797',
    },
    {
      id:    'coronilla',
      title: 'La coronilla',
      how:   'Apunta a tu remolino, la parte de atrás y arriba de la cabeza. El médico necesita ver bien tu coronilla.',
      ref:   'https://cdn.shopify.com/s/files/1/0748/2107/4967/files/back.png?v=1788995797',
    },
    {
      id:    'perfil_izq',
      title: 'Perfil izquierdo',
      how:   'De lado, mostrando tu oreja izquierda. El médico necesita ver tu entrada y la densidad de ese costado.',
      ref:   'https://cdn.shopify.com/s/files/1/0748/2107/4967/files/left.png?v=1788995797',
    },
    {
      id:    'perfil_der',
      title: 'Perfil derecho',
      how:   'De lado, mostrando tu oreja derecha. El médico necesita ver tu entrada y la densidad de ese costado.',
      ref:   'https://cdn.shopify.com/s/files/1/0748/2107/4967/files/right.png?v=1788995797',
    },
  ];

  // Precargar imágenes de referencia
  PHOTO_SLOTS.forEach(function(s) {
    var img = new Image(); img.src = s.ref;
  });

  // ── Render: barra de progreso tipo intake ─────────────────────────────────
  function renderProgress(idx) {
    var COL_DONE   = 'var(--omme-ink-1000, #1a1a18)';
    var COL_ACTIVE = 'var(--omme-accent, #E8F06B)';
    var COL_REST   = 'var(--omme-ink-a08, rgba(13,13,13,0.08))';

    var segs = '';
    for (var i = 0; i < PHOTO_SLOTS.length; i++) {
      var color = i < idx ? COL_DONE : i === idx ? COL_ACTIVE : COL_REST;
      segs += '<div style="display:block !important;flex:1 1 0%;min-width:0;height:2px;border-radius:999px;background:' + color + ';transition:background 400ms ease;"></div>';
    }

    return (
      '<div role="progressbar" aria-valuemin="1" aria-valuemax="' + PHOTO_SLOTS.length + '" aria-valuenow="' + (idx + 1) + '" aria-label="Foto ' + (idx + 1) + ' de ' + PHOTO_SLOTS.length + '" style="display:flex;flex-direction:column;gap:8px;padding:16px 0 12px;margin-bottom:8px;">' +
        '<div style="display:flex !important;flex-direction:row !important;gap:4px;width:100%;align-items:center;">' + segs + '</div>' +
        '<div style="display:flex;justify-content:space-between;align-items:center;">' +
          '<span style="font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:0.12em;color:var(--omme-ink-500,#888780);">Foto ' + (idx + 1) + ' de ' + PHOTO_SLOTS.length + '</span>' +
          '<span style="font-size:11px;font-weight:600;color:var(--omme-ink-1000,#1a1a18);">Evidencia fotográfica</span>' +
        '</div>' +
      '</div>'
    );
  }

  // ── Render: error de configuración / sin id ───────────────────────────────
  function renderInvalidState(msg) {
    hideLoader();
    var wa = (cfg.waNumber || '').replace(/\D/g, '');
    ROOT.innerHTML =
      '<div class="fotos-error-state">' +
        '<h2>No pudimos cargar tu solicitud</h2>' +
        '<p>' + esc(msg || 'El enlace que usaste no es válido o ya expiró. Escríbenos y te enviamos uno nuevo.') + '</p>' +
        (wa ? (
          '<a href="https://wa.me/' + wa + '?text=' + encodeURIComponent('Hola, necesito el enlace para subir mis fotos de Omme.') + '" ' +
          'class="intake-exclusion__cta" target="_blank" rel="noopener">' +
            _waIcon() +
            'Escríbenos por WhatsApp' +
          '</a>'
        ) : '') +
      '</div>';
  }

  // ── Render: pantalla de confirmación final ────────────────────────────────
  function renderConfirmation() {
    var wa = (cfg.waNumber || '').replace(/\D/g, '');
    var saludo = state.nombre ? ('¡Listo, ' + esc(state.nombre) + '!') : '¡Fotos recibidas!';
    ROOT.innerHTML =
      '<div class="intake-confirmation" style="text-align:center;">' +
        '<div class="fotos-success-icon">' +
          '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1a1a18" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>' +
        '</div>' +
        '<h1 class="intake-confirmation__title">' + saludo + '</h1>' +
        '<p class="intake-confirmation__body">' +
          'El Dr. Limón ya puede revisar tu caso completo. Te escribiremos por WhatsApp en las próximas 48 horas con tu plan de tratamiento personalizado.' +
        '</p>' +
        (wa ? (
          '<a href="https://wa.me/' + wa + '?text=' + encodeURIComponent('Hola, acabo de subir mis fotos en Omme. ¿Cuándo me contactan?') + '" ' +
          'class="intake-exclusion__cta" target="_blank" rel="noopener" style="display:inline-flex;">' +
            _waIcon() +
            'Escríbenos por WhatsApp' +
          '</a>'
        ) : '') +
      '</div>';

    ROOT.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ── Render: slot de foto ──────────────────────────────────────────────────
  function renderSlot() {
    var idx   = state.slotIndex;
    var slot  = PHOTO_SLOTS[idx];
    var photo = state.photos[slot.id];
    var isLast = (idx === PHOTO_SLOTS.length - 1);

    // Saludo personalizado solo en slot 0
    var greetingHtml = '';
    if (idx === 0 && state.nombre) {
      greetingHtml =
        '<p class="intake-step__eyebrow" style="color:var(--omme-ink-700,#4a4a47);text-transform:none;letter-spacing:0;font-size:14px;font-weight:500;">' +
          'Hola, ' + esc(state.nombre) + '. Estás a punto de completar tu expediente.' +
        '</p>';
    }

    // Área de foto
    var photoArea;
    if (photo) {
      photoArea =
        '<div class="fotos-preview">' +
          '<img src="' + esc(photo.url) + '" alt="' + esc(slot.title) + '">' +
          '<div class="fotos-preview-label">✓ ' + esc(slot.title) + '</div>' +
        '</div>' +
        '<div id="fotos-progress-bar" style="display:none;" class="fotos-progress-bar">' +
          '<div id="fotos-progress-fill" class="fotos-progress-fill" style="width:0%;"></div>' +
        '</div>';
    } else {
      photoArea =
        '<img class="omme-photo-ref-img" src="' + esc(slot.ref) + '" alt="Referencia: ' + esc(slot.title) + '">' +
        '<div id="fotos-progress-bar" style="display:none;" class="fotos-progress-bar">' +
          '<div id="fotos-progress-fill" class="fotos-progress-fill" style="width:0%;"></div>' +
        '</div>';
    }

    // Botón principal — todos los slots usan capture="environment" (cámara trasera)
    var actionBtn;
    if (photo) {
      actionBtn =
        '<button class="fotos-upload-btn fotos-upload-btn--secondary" type="button" id="fotos-retake">' +
          'Tomar otra foto' +
          '<input type="file" accept="image/*" capture="environment" id="fotos-input" style="display:none;">' +
        '</button>';
    } else {
      actionBtn =
        '<label class="fotos-upload-btn" id="fotos-upload-btn" role="button" tabindex="0">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>' +
          '<span>Subir mi foto</span>' +
          '<input type="file" accept="image/*" capture="environment" id="fotos-input" style="display:none;">' +
        '</label>';
    }

    ROOT.innerHTML =
      '<div class="fotos-step">' +
        renderProgress(idx) +
        greetingHtml +
        '<h1 class="intake-step__title">' + esc(slot.title) + '</h1>' +
        '<p class="intake-step__subtitle">' + esc(slot.how) + '</p>' +
        photoArea +
        '<span class="intake-field__error" id="e-fotos" style="display:none;"></span>' +
        actionBtn +
        '<div class="intake-nav">' +
          (idx > 0
            ? '<button class="intake-btn--back" type="button" id="fotos-back">← Anterior</button>'
            : '<span></span>'
          ) +
          '<button class="intake-btn--next" type="button" id="fotos-next"' +
            (!photo ? ' disabled' : '') +
          '>' + esc(isLast ? 'Enviar fotos' : 'Siguiente foto') + '</button>' +
        '</div>' +
      '</div>';

    // Bind file input
    var input = document.getElementById('fotos-input');
    if (input) {
      input.addEventListener('change', function() {
        if (input.files && input.files[0]) {
          // FIX: Validar tipo y tamaño antes de subir
          var file = input.files[0];
          if (!validateFile(file)) return;
          uploadToCloudinary(file, slot.id);
        }
      });
    }

    // Retake button: trigger the hidden file input inside it
    var retakeBtn = document.getElementById('fotos-retake');
    if (retakeBtn && input) {
      retakeBtn.addEventListener('click', function() {
        input.click();
      });
    }

    // Bind next
    var nextBtn = document.getElementById('fotos-next');
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        if (!state.photos[slot.id]) {
          showError('e-fotos', 'Por favor sube la foto antes de continuar.');
          return;
        }
        clearError('e-fotos');
        if (idx < PHOTO_SLOTS.length - 1) {
          state.slotIndex++;
          renderSlot();
          ROOT.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          renderConfirmation();
        }
      });
    }

    // Bind back
    var backBtn = document.getElementById('fotos-back');
    if (backBtn) {
      backBtn.addEventListener('click', function() {
        if (state.slotIndex > 0) {
          state.slotIndex--;
          renderSlot();
          ROOT.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }

  // ── FIX: Validación de archivo ────────────────────────────────────────────
  function validateFile(file) {
    // Tipo permitido
    if (ALLOWED_TYPES.indexOf(file.type) === -1) {
      // HEIC a veces llega con type="" en iOS — lo dejamos pasar si tiene extensión .heic/.heif
      var ext = (file.name || '').split('.').pop().toLowerCase();
      if (ext !== 'heic' && ext !== 'heif') {
        showError('e-fotos', 'Solo se aceptan fotos en formato JPG, PNG o HEIC.');
        return false;
      }
    }
    // Tamaño máximo
    if (file.size > MAX_FILE_SIZE) {
      showError('e-fotos', 'La foto pesa más de 25 MB. Usa una de menor resolución.');
      return false;
    }
    clearError('e-fotos');
    return true;
  }

  // ── Upload a Cloudinary desde browser ─────────────────────────────────────
  function uploadToCloudinary(file, slotId) {
    if (_uploadInProgress) return;
    _uploadInProgress = true;

    var cloudName = (cfg.cloudinaryCloud || '').trim();
    var preset    = (cfg.cloudinaryPreset || '').trim();

    // FIX: Eliminado console.log con credenciales
    if (!cloudName || !preset) {
      showError('e-fotos', 'Error de configuración. Contacta a soporte.');
      _uploadInProgress = false;
      return;
    }

    clearError('e-fotos');

    var uploadBtn    = document.getElementById('fotos-upload-btn') || document.getElementById('fotos-retake');
    var progressBar  = document.getElementById('fotos-progress-bar');
    var progressFill = document.getElementById('fotos-progress-fill');
    if (uploadBtn)    uploadBtn.style.opacity = '0.5';
    if (progressBar)  progressBar.style.display = 'block';

    var formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', preset);
    formData.append('folder', 'omme/intake');
    formData.append('public_id', (state.recordId || 'unknown') + '_' + slotId + '_' + Date.now());

    var xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + cloudName + '/image/upload');

    xhr.upload.onprogress = function(e) {
      if (e.lengthComputable && progressFill) {
        progressFill.style.width = Math.round((e.loaded / e.total) * 100) + '%';
      }
    };

    xhr.onload = function() {
      _uploadInProgress = false;
      if (uploadBtn) uploadBtn.style.opacity = '1';

      if (xhr.status === 200) {
        var result;
        try { result = JSON.parse(xhr.responseText); } catch(e) {
          showError('e-fotos', 'Error al procesar la respuesta. Intenta de nuevo.');
          return;
        }

        state.photos[slotId] = { url: result.secure_url, publicId: result.public_id };

        // Guardar en Airtable vía PipeDream (async, no bloqueamos UX)
        saveToAirtable(slotId, result.secure_url);

        renderSlot();
        ROOT.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        console.error('[Omme Fotos] Cloudinary error:', xhr.status);
        showError('e-fotos', 'No se pudo subir la foto. Verifica tu conexión e intenta de nuevo.');
      }
    };

    xhr.onerror = function() {
      _uploadInProgress = false;
      if (uploadBtn) uploadBtn.style.opacity = '1';
      console.error('[Omme Fotos] XHR network error');
      showError('e-fotos', 'No se pudo subir la foto. Verifica tu conexión e intenta de nuevo.');
    };

    xhr.send(formData);
  }

  // ── Guardar URL en Airtable vía PipeDream ─────────────────────────────────
  // FIX: webhookSecret eliminado — el header x-omme-secret ya no viene del cliente.
  // El secreto vive únicamente en PipeDream como variable de entorno.
  async function saveToAirtable(slotId, cloudinaryUrl) {
    var uploadUrl = (cfg.uploadUrl || '').trim();
    if (!uploadUrl) {
      console.warn('[Omme Fotos] uploadUrl not configured — skipping Airtable save');
      return;
    }
    if (!state.recordId) {
      console.warn('[Omme Fotos] No record_id in state — skipping Airtable save');
      return;
    }

    try {
      var res = await fetch(uploadUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          record_id: state.recordId,
          photo: {
            tipo:           slotId,
            kapso_url: cloudinaryUrl,
          },
        }),
      });

      var data = await res.json();
      if (!data.ok) {
        console.warn('[Omme Fotos] PipeDream returned error:', data.error);
      }
    } catch(e) {
      console.warn('[Omme Fotos] Could not save to Airtable:', e.message);
    }
  }

  // ── Icono WhatsApp (reutilizable) ─────────────────────────────────────────
  function _waIcon() {
    return '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style="flex-shrink:0;"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.374 0 0 5.373 0 12c0 2.117.549 4.107 1.514 5.842L.058 23.902l6.228-1.632A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.628 0 12 0zm0 21.818a9.818 9.818 0 01-5.003-1.367l-.36-.213-3.696.969.987-3.595-.235-.371A9.818 9.818 0 012.182 12C2.182 6.579 6.579 2.182 12 2.182S21.818 6.579 21.818 12 17.421 21.818 12 21.818z"/></svg>';
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  showLoader('Cargando tu solicitud…', 'Un momento');

  if (!rawId) {
    renderInvalidState('El enlace no contiene el identificador de tu solicitud. Escríbenos y te enviamos uno nuevo.');
    return;
  }

  var lookupUrl = (cfg.lookupUrl || '').trim();
  if (!lookupUrl) {
    // Sin lookupUrl configurado: modo degradado — arrancamos sin nombre ni validación
    console.warn('[Omme Fotos] lookupUrl not configured — starting without lookup');
    if (isAirtableId) state.recordId = rawId;
    setTimeout(function() {
      hideLoader();
      renderSlot();
      ROOT.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 400);
    return;
  }

  // Construir URL del lookup con el parámetro correcto
  var lookupParam = isAirtableId
    ? 'record_id=' + encodeURIComponent(rawId)
    : 'intake_id=' + encodeURIComponent(rawId);

  // FIX: AbortController + timeout de 15s para el lookup
  var controller = new AbortController();
  var timeoutId  = setTimeout(function() { controller.abort(); }, 15000);

  fetch(lookupUrl + '?' + lookupParam, { signal: controller.signal })
    .then(function(r) {
      clearTimeout(timeoutId);
      return r.json();
    })
    .then(function(data) {
      if (!data.ok) {
        renderInvalidState(
          data.error === 'not_found'
            ? 'No encontramos tu solicitud. Es posible que el enlace haya expirado. Escríbenos y te enviamos uno nuevo.'
            : 'Hubo un problema al cargar tu solicitud. Intenta de nuevo o escríbenos.'
        );
        return;
      }

      state.recordId = data.record_id;
      var raw = (data.nombre || '').trim();
      state.nombre = raw
        ? raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase()
        : null;

      hideLoader();
      renderSlot();
      ROOT.scrollIntoView({ behavior: 'smooth', block: 'start' });
    })
    .catch(function(e) {
      clearTimeout(timeoutId);
      if (e.name === 'AbortError') {
        console.warn('[Omme Fotos] Lookup timeout — degraded mode');
      } else {
        console.warn('[Omme Fotos] Lookup failed:', e.message);
      }
      // En caso de error o timeout: modo degradado
      if (isAirtableId) state.recordId = rawId;
      hideLoader();
      renderSlot();
      ROOT.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

})();